import m from "../../geodata/es2015/czechRepublicHigh";
window.am4geodata_czechRepublicHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/czechRepublicHigh.js
// module id = null
// module chunks = 